import React__default from 'react';
import OpenChannelUI from './OpenChannelSettings/components/OpenChannelSettingsUI.js';
import { OpenChannelSettingsProvider } from './OpenChannelSettings/context.js';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './chunks/bundle-CxLxJCBu.js';
import './chunks/bundle-d1cOX5nv.js';
import './chunks/bundle-DS1EhNtb.js';
import './chunks/bundle-CjJk57u5.js';
import './ui/Icon.js';
import './chunks/bundle-kFa80LJe.js';
import './ui/PlaceHolder.js';
import './ui/Loader.js';
import './OpenChannelSettings/components/OperatorUI.js';
import './OpenChannelSettings/components/OpenChannelProfile.js';
import './ui/TextButton.js';
import './chunks/bundle-B5157rdG.js';
import './ui/OpenChannelAvatar.js';
import './chunks/bundle-DOfhjbKd.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-C_zEpfCP.js';
import './chunks/bundle-BlguTwHI.js';
import './OpenChannelSettings/components/EditDetailsModal.js';
import './chunks/bundle-mqagBpi9.js';
import './chunks/bundle-DRpjMk0B.js';
import './chunks/bundle-BA9oFJ90.js';
import '@sendbird/chat/groupChannel';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-DiK8ifY3.js';
import './chunks/bundle-C-nZYnmy.js';
import './chunks/bundle-DP3z2QNm.js';
import 'react-dom';
import './chunks/bundle-Ci-RNuvu.js';
import './ui/IconButton.js';
import './ui/Button.js';
import '@sendbird/uikit-tools';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import './chunks/bundle-DKdROCX_.js';
import '@sendbird/chat/openChannel';
import './chunks/bundle-DdJ9pMWn.js';
import './chunks/bundle-BzR1dD25.js';
import './ui/SortByRow.js';
import './ui/Input.js';
import './chunks/bundle-DTvXJ1Ss.js';
import './chunks/bundle-DXFVroy5.js';
import './ui/AccordionGroup.js';
import './ui/MutedAvatarOverlay.js';
import './ui/UserProfile.js';
import './sendbirdSelectors.js';
import './ui/UserListItem.js';
import './ui/Checkbox.js';
import './ui/Accordion.js';

var OpenChannelSetting = function (props) {
    return (React__default.createElement(OpenChannelSettingsProvider, { channelUrl: props === null || props === void 0 ? void 0 : props.channelUrl, onCloseClick: props === null || props === void 0 ? void 0 : props.onCloseClick, onBeforeUpdateChannel: props === null || props === void 0 ? void 0 : props.onBeforeUpdateChannel, onChannelModified: props === null || props === void 0 ? void 0 : props.onChannelModified, onDeleteChannel: props === null || props === void 0 ? void 0 : props.onDeleteChannel, disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile, renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile },
        React__default.createElement(OpenChannelUI, { renderOperatorUI: props === null || props === void 0 ? void 0 : props.renderOperatorUI, renderParticipantList: props === null || props === void 0 ? void 0 : props.renderParticipantList })));
};

export { OpenChannelSetting as default };
//# sourceMappingURL=OpenChannelSettings.js.map
